// src/store/tour-store.ts
import { create } from 'zustand';

interface TourState {
  isTourEnabled: boolean;
  setTourEnabled: (enabled: boolean) => void;
}

export const useTourStore = create<TourState>((set) => ({
  // Initialize from localStorage to remember the user's preference
  isTourEnabled: localStorage.getItem('isTourEnabled') === 'true',
  
  setTourEnabled: (enabled: boolean) => {
    localStorage.setItem('isTourEnabled', String(enabled));
    set({ isTourEnabled: enabled });
  },
}));